import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/api";
import { Instagram, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0B0B0B] border-t border-[rgba(184,147,90,0.2)] pt-20 pb-10 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-14">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <span className="serif text-3xl tracking-[0.35em] text-[#F7F3EC]">NOIR</span>
              <span className="w-8 h-px bg-[#B8935A]" />
              <span className="serif text-3xl tracking-[0.35em] text-[#F7F3EC]">NAILS</span>
            </div>
            <p className="serif-italic mt-6 text-lg text-[#A1A1AA] max-w-md leading-relaxed">
              Your style. Your statement. Your NOIR.
            </p>
            <div className="gold-line mt-8 max-w-xs" />
            <p className="mt-6 text-sm text-[#A1A1AA] leading-relaxed max-w-md">
              A premium boutique nail studio in Whitefield, Bangalore — crafting nails with care, creativity and attention to detail.
            </p>
          </div>

          <div>
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><a href="/#top" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Home</a></li>
              <li><a href="/#story" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Our Story</a></li>
              <li><a href="/#services" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Services</a></li>
              <li><Link to="/book" data-testid="footer-book-link" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Book Appointment</Link></li>
              <li><a href="/#location" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Location</a></li>
              <li><a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">Instagram</a></li>
              <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="text-[#F7F3EC] hover:text-[#B8935A] transition-colors">WhatsApp</a></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-5">Visit</p>
            <p className="text-sm text-[#A1A1AA] leading-relaxed">{CONTACT.address}</p>
            <p className="eyebrow mt-8 mb-3">Hours</p>
            <p className="text-sm text-[#A1A1AA]">{CONTACT.hours}</p>
            <div className="mt-6 flex flex-wrap gap-4">
              <a href={`tel:+91${CONTACT.phone}`} className="text-[#B8935A] text-sm inline-flex items-center gap-2" data-testid="footer-call"><Phone size={14} />Call</a>
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="text-[#B8935A] text-sm inline-flex items-center gap-2" data-testid="footer-whatsapp">WhatsApp</a>
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="text-[#B8935A] text-sm inline-flex items-center gap-2" data-testid="footer-instagram"><Instagram size={14} />Instagram</a>
              <a href={CONTACT.mapsUrl} target="_blank" rel="noreferrer" className="text-[#B8935A] text-sm inline-flex items-center gap-2" data-testid="footer-directions"><MapPin size={14} />Directions</a>
            </div>
          </div>
        </div>

        <div className="hairline mt-16" />
        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#A1A1AA] tracking-[0.2em] uppercase">
          <span>© 2026 NOIR NAILS. All rights reserved.</span>
          <span>Whitefield · Bangalore</span>
        </div>
      </div>
    </footer>
  );
}
